module.exports = {"id":"167943","name":"Yohan Cabaye","rating":"78","photo":"./data/images/photos/2/167943.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YohanCabaye0.json
// module id = 4418
// module chunks = 0